import { Directive } from '@angular/core';

@Directive({
    selector: '[appDocumentOptions]',
    standalone: false
})
export class OptionsDirective {}
